import { IPR_EXCLUDED_PROTECTION_TYPES } from 'redpoints-front-common/helpers';
import { fetchReducerGenerator } from 'redpoints-front-common/reducers';

import {
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_PROTECTION_TYPES,
} from '../../../../actions/actionTypes';
import { translate } from '../../../../helpers/languageHelper';

export default fetchReducerGenerator(
  ALL_INCIDENTS_CLEAR,
  ALL_INCIDENTS_FILTERS_FETCH_PROTECTION_TYPES
);

export const getAllIncidentsProtectionTypesResponse = state =>
  (state.response?.data?.protectionTypes || [])
    .filter(
      item => !IPR_EXCLUDED_PROTECTION_TYPES.includes(item.protectionType.name)
    )
    .map(row => ({
      key: row.protectionType.name,
      value: translate(`global.protectiontype.${row.protectionType.name}`),
    }));
